import { boot } from "quasar/wrappers";
import { LoadingMonitor } from "src/utils/LoadingMonitor";

export default boot(({ app }) => {
  // Expose to Vue prototype for easy access in components
  app.config.globalProperties.$performance = LoadingMonitor;
});

export { LoadingMonitor };
